import appConfig from 'app-config'
import actions from 'redux/actions'
import { constants, getTrackingEventToNavItem, links, mixpanel, snowplow } from 'common/helpers'

import messages from './messages'


const addEvents = (nav) => nav.map((item) => getTrackingEventToNavItem(item, {
  mixpanelEvent: constants.analyticsEvents.profileMenuMobile,
}))

const getNav = ({ isUndeliverable, isCancelled, isUpgradable, isPaused, isPrepaidPlansLandingPageEnabled }) => {

  let nav = [
    {
      title: messages.tracking,
      to: links.tracking,
      dataTestId: 'tracking',
    },
    {
      title: messages.subscriptionStatus,
      to: links.profile.ordersStatus,
      dataTestId: 'subscriptionStatus',
    },
  ]

  if (isCancelled) {
    nav.push({
      title: messages.resubscribe,
      dataTestId: 'resubscribe',
      onClick: () => {
        const resubscribeCode = constants.resubscribeTypes.resubnew

        snowplow.track(constants.snowplowEvents.resubscribeClick, {
          placement: 'profile menu',
        })

        if (isUndeliverable) {
          actions.models.router.push(`${links.subscribe}?resubscribeCode=${resubscribeCode}`)
        }
        else {
          actions.models.subscription.resubscribe({ resubscribeCode, popup: 'profile menu' })
            .then(({ premiumProduct }) => {
              if (premiumProduct) {
                actions.models.modals.open(constants.modals.premiumProducts.WelcomeBack, {
                  item: premiumProduct,
                })
              }
              else {
                actions.models.modals.open(constants.modals.resubscribe.ResubscribeSuccess)
              }
            }, () => {})
        }
      },
    })
  }

  if (isUpgradable) {
    nav.push({
      title: messages.upgradeYourPlan,
      emojiIcon: '💰',
      dataTestId: 'upgradeYourPlan',
      onClick: () => {
        actions.models.ui.closeProfileMenu()
        snowplow.track(constants.snowplowEvents.upgradeSubscriptionClick, { placement: 'hamburger menu' }, false)
        actions.models.subscription.handleUpgradeClick({ placement: 'mobile menu dropdown in profile' })
      },
    })
  }

  if (isPrepaidPlansLandingPageEnabled) {
    nav.push({
      title: messages.prepaidPlans,
      emojiIcon: '🔥 ',
      to: links.upgradePrepaid,
      dataTestId: 'prepaidPlans',
    })
  }

  if (isPaused) {
    nav.push({
      title: messages.unpause,
      dataTestId: 'unpause',
      onClick: () => {
        snowplow.track(constants.snowplowEvents.unpauseClick, { placement: 'hamburger menu' }, false)
        actions.models.subscription.unpause({ placement: 'hamburger menu' })
      },
    })
  }

  nav.push(
    { title: messages.myOrders,             to: links.profile.myOrders, dataTestId: 'myOrders' },
    { title: messages.personalInfo,         to: links.profile.personal, dataTestId: 'personal' },
    { title: messages.billingAndShipping,   to: links.profile.billingAndShipping, dataTestId: 'billingAndShipping' },
    { title: messages.giftSent,             to: links.profile.sentGifts, dataTestId: 'giftSent' },
    { title: messages.changePassword,       to: links.profile.password, dataTestId: 'password' },
    { title: messages.referAFriend,         to: links.invite, dataTestId: 'invite' }
  )

  nav.push(
    { isSeparator: true },
    {
      title: messages.logout,
      href: links.logout,
      id: 'logout',
      onClick: (event) => {
        mixpanel.reset()
        actions.models.me.removeStorageData()

        console.log(event)

        if (process.env.LOCALTEST || process.env.WEBPACK === 'dev') {
          if (event) {
            event.preventDefault()
          }
          window.open(`${appConfig.services.api}logoff`)

          setTimeout(() => {
            window.location.pathname = links.login
          }, 500)
        }
      },
    },
  )

  return addEvents(nav)
}


export {
  getNav,
}
